"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Loader = function () { return (react_1.default.createElement("div", { className: "async-loader" },
    react_1.default.createElement("div", { className: "background" },
        react_1.default.createElement("div", { className: "animation" },
            react_1.default.createElement("div", { className: "loader" }))))); };
exports.default = Loader;
//# sourceMappingURL=Loader.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/Grid/Loader.js
// module id = 1930
// module chunks = 0